import { QueryConfig } from "store/utils/query-config";

export const engagementDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
